import { Box } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import instantFail from 'shared/modules/superpay/assets/instant_fail.gif';
import instantLoading from 'shared/modules/superpay/assets/instant_loading.gif';
import instantSuccess from 'shared/modules/superpay/assets/instant_success.gif';
import instantFailDark from 'shared/modules/superpay/assets/instant_fail_dark.gif';
import instantLoadingDark from 'shared/modules/superpay/assets/instant_loading_dark.gif';
import instantSuccessDark from 'shared/modules/superpay/assets/instant_success_dark.gif';
import { SuperPayInstantTransferConfirmDTO } from 'shared/modules/superpay/SuperPayDTO';
import { Image } from '@superdispatch/ui';

export function isConfirmIllustrationState(
  status: SuperPayInstantTransferConfirmDTO['status'],
) {
  return ['loading', 'completed', 'failed'].includes(status);
}

const statusImages: Record<string, { light: string; dark: string }> = {
  loading: { light: instantLoading, dark: instantLoadingDark },
  completed: { light: instantSuccess, dark: instantSuccessDark },
  failed: { light: instantFail, dark: instantFailDark },
};
interface ConfirmLoadingStateProps {
  status: SuperPayInstantTransferConfirmDTO['status'] | 'loading';
}

export function InstantTransferConfirmLoadingState({
  status,
}: ConfirmLoadingStateProps) {
  const images = statusImages[status];
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      padding="medium"
      minHeight={isWebView ? '100%' : '520px'}
      height="100%"
    >
      <Box height="auto" width="100%" maxWidth="400px">
        {images && (
          <Image
            src={images.light}
            srcDark={images.dark}
            alt="instant loading illustration"
            width="100%"
          />
        )}
      </Box>
    </Box>
  );
}
